import {
  InspectionTemplateDetail,
  InspectionTemplate,
  Question,
  Result,
} from "src/data/types";

export const inspectionTemplates: InspectionTemplate[] = [
  {
    templateId: "660f9500-f39c-42e5-b27-557766551111",
    templateName: "Daily Equipment Safety Check",
    inspectionType: "EQUIPMENT_CHECK",
    frequency: "WEEKLY",
    createdBy: "admin123",
    siteCode: "ABE3",
    questions: [
      {
        questionId: "770a0600-g40d-43f6-c938-6688762222",
        questionText:
          "Are forklift safety lights functioning, and forklift inspection completed?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d049-77998877333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e150-88a99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43f6-c98-668877662222",
        questionText: "Are fire extinguisher on place?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d049-77988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e50-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43f6-c938-68877662222",
        questionText: "Are all lights are working?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d09-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43f6-c938-6688776622",
        questionText: "Are all doors closed ans secured?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-4g7-d049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62-45h8-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a00-g40d-43f6-c938-668877662222",
        questionText:
          "Are garbage bins located in the right place and labeled?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h5e-44g7-d049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i6f-45h8-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
    ],
  },
  {
    templateId: "6609500-f39c-42e5-b827-557766551111",
    templateName: "Weekly Workers Safety Check",
    inspectionType: "EQUIPMENT_CHECK",
    frequency: "WEEKLY",
    createdBy: "admin123",
    siteCode: "ABE3",
    questions: [
      {
        questionId: "770a0600-g40d-43f-c938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d049-7799873333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-62f-45h8-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g0d-43f6-c938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-47-d049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c280-i62f-45h8-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "70a0600-g40d-43f6-c938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b170h51e-44g7-d049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c20-i62f-45h8-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43f6-c938-6688772222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "881700-h51e-44g7-d049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990800-i62f-45h8-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43f6-c938-66877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e150-88aa984444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a060-g40d-43f6-c938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g749-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e150-aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
    ],
  },
  {
    templateId: "660f9500-f39c-42e5-b827-557766551111",
    templateName: "Monthly Working Area Safety Check",
    inspectionType: "EQUIPMENT_CHECK",
    frequency: "WEEKLY",
    createdBy: "admin123",
    siteCode: "ABE3",
    questions: [
      {
        questionId: "77a0600-g40d-43f6-c938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-7-d049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45he150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43fc938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d049-779988773",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e150-88aa9984",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43f6-c98-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d0988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e150-88aa99884444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "70a0600-g40d-43f6-c938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d049773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e150-88aa9988444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
      {
        questionId: "770a0600-g40d-43f6-c938-668877662222",
        questionText: "Are forklift safety lights functioning?",
        instruction:
          "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
        answerType: "YES_NO",
        examples: [
          {
            exampleId: "880b1700-h51e-44g7-d049-779988773333",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
            exampleType: "POSITIVE_EXAMPLE",
            expectedResult: "YES",
          },
          {
            exampleId: "990c2800-i62f-45h8-e150-88aa9988444",
            imageURL:
              "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
            exampleType: "NEGATIVE_EXAMPLE",
            expectedResult: "NO",
          },
        ],
      },
    ],
  },
];
export const inspectionDetails: InspectionTemplateDetail[] = [
  {
    name: "Fire Safety Daily Inspection",
    inspectionType: "Safety Inspection",
    location: "Warehouse B",
    frequency: "Weekly",
    mandate: "Mandatory",
    status: "Draft",
  },
  {
    name: "PPE Inspection Warehouse B",
    inspectionType: "Safety Inspection",
    location: "Site ABE2",
    frequency: "Daily",
    mandate: "Mandatory",
    status: "Active",
  },
];
export const sampleQuestion: Question = {
  questionId: "770a0600-g40d-43f6-c938-668877662222",
  questionText: "Are forklift safety lights functioning?",
  instruction:
    "Check that all safety lights on the forklift are operational. This includes front headlights, rear taillights, warning beacons, and any strobe lights. Test each light by turning on the forklift and activating all lighting systems.",
  answerType: "YES_NO",
  examples: [
    {
      exampleId: "880b1700-h51e-44g7-d049-779988773333",
      imageURL:
        "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/880b1700-h51e-44g7-d049-779988773333/forklift-lights-good.jpg",
      exampleType: "POSITIVE_EXAMPLE",
      expectedResult: "YES",
    },
    {
      exampleId: "990c2800-i62f-45h8-e150-88aa99884444",
      imageURL:
        "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
      exampleType: "NEGATIVE_EXAMPLE",
      expectedResult: "NO",
    },
    {
      exampleId: "990c2800-i62f-45h8-e150-88aa998b4444",
      imageURL:
        "https://s3.amazonaws.com/examples/770a0600-g40d-43f6-c938-668877662222/990c2800-i62f-45h8-e150-88aa99884444/forklift-lights-broken.jpg",
      exampleType: "NEGATIVE_EXAMPLE",
      expectedResult: "NO",
    },
  ],
};
export const initialResult: Result = {
  resultId: "",
  questionId: "",
  aiResult: "",
  confirmedResult: "",
  isCompliant: false,
  isInspectorOverride: false,
  overrideReason: "",
  evidence: [],
};
